export default "__VITE_ASSET__62e5caf9__"